import { ROUTES } from ".";

export const MANAGE_COMMUNICATION_ROUTES = {
  PLAN_LEVEL_COMMUNICATION: `${ROUTES.MANAGE_COMMUNICATION}/plan-level-communication`,
  COMMUNICATION: `${ROUTES.MANAGE_COMMUNICATION}/communication`,
  NEW_COMMUNICATION: `${ROUTES.MANAGE_COMMUNICATION}/new-communication`,
  COMMUNICATION_HISTORY: `${ROUTES.MANAGE_COMMUNICATION}/Communication-history`,
  EMAIL_LAYOUT: `${ROUTES.MANAGE_COMMUNICATION}/email-layout`,
  CONFIGURE_COMMUNICATION: `${ROUTES.MANAGE_COMMUNICATION}/configure-communication`,
  COMMUNICATION_INFO: `${ROUTES.MANAGE_COMMUNICATION}/communication-info`,
  COMMUNICATION_HISTORY_INFO: `${ROUTES.MANAGE_COMMUNICATION}/Communication-history-info`,
  EMAIL_LAYOUT_INFO: `${ROUTES.MANAGE_COMMUNICATION}/email-layout-info`,
};

export const MANAGE_COMMUNICATION_MENU = [
  {
    label: "Communications",
    subNav: [
      {
        id: "planLevelCommunication",
        label: "Plan Communication",
        path: MANAGE_COMMUNICATION_ROUTES.PLAN_LEVEL_COMMUNICATION,
        contentHeader: "Plan Communication",
        breadCrumbs: [],
        childRoutes: [MANAGE_COMMUNICATION_ROUTES.CONFIGURE_COMMUNICATION],
      },
      {
        id: "communication",
        label: "Manage Communication",
        path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION,
        contentHeader: "Manage Communication",
        breadCrumbs: [],
        childRoutes: [
          MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO,
          MANAGE_COMMUNICATION_ROUTES.NEW_COMMUNICATION,
        ],
      },
    ],
  },
  {
    id: "emailLayout",
    label: "E-Mail Layout",
    path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT,
    contentHeader: "E-Mail Layout",
    breadCrumbs: [],
    childRoutes: [MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT_INFO],
  },
  {
    id: "communicationHistory",
    label: "Communication History",
    path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY,
    contentHeader: "Communication History",
    breadCrumbs: [],
    childRoutes: [MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY_INFO],
  },
];

export const manageCommunicationFormNames = {
  PLAN_LEVEL_COMMUNICATION: "plan level communication",
  COMMUNICATION: "communication",
  NEW_COMMUNICATION: "new communication",
  COMMUNICATION_HISTORY: "communication history",
  EMAIL_LAYOUT: "email layout",
  CONFIGURE_COMMUNICATION: "configure communication",
  COMMUNICATION_INFO: "communication info",
  COMMUNICATION_HISTORY_INFO: "communication history info",
  EMAIL_LAYOUT_INFO: "email layout info",
};
export const communicationFormFields = {
  [manageCommunicationFormNames.PLAN_LEVEL_COMMUNICATION]: {
    planName: "planName",
    type: "type",
    search: "search",
    eventName: "eventName",
    eventCategory: "eventCategory",
    categorizedLevel: "categorizedLevel",
    fromDate: "fromDate",
    toDate: "toDate",
    planId: "planId",
    planGroupId: "planGroupId",
  },
  [manageCommunicationFormNames.COMMUNICATION_INFO]: {
    channel: "channel",
    name: "name",
    communicationBlobAttachment: "communicationBlobAttachment",
    description: "description",
    subjectMetaData: "subjectMetaData",
    sendTo: "sendTo",
    cc: "cc",
    subject: "subject",
    levelOfCommunication: "level",
    planId: "planId",
    planGroupId: "planGroupId",
    planMappings: "planMappings",
    planGroupMappings: "planGroupMappings",
    type: "type",
    event: "event",
    eventId: "eventId",
    eventType: "eventType",
    eventCategory: "eventCategory",
    subEvent: "subEvent",
    scheduleName: "scheduleName",
    frequencyType: "frequencyType",
    //startDay: "startDay",
    weekly_StartDay: "weekly_StartDay",
    biWeekly_StartDate: "biWeekly_StartDate",
    // startDate: "startDate",
    // firstBeginDay: "firstBeginDay",
    // secondBeginDay: "secondBeginDay",
    semiMonthly_FirstDay: "semiMonthly_FirstDay",
    semiMonthly_SecondDay: "semiMonthly_SecondDay",
    monthly_StartDay: "monthly_StartDay",
    quarterly_StartsFrom: "quarterly_StartsFrom",
    semiAnnually_StartsFrom: "semiAnnually_StartsFrom",
    annually_StartsFrom: "annually_StartsFrom",
    anually_StartDate: "anually_StartDate",
    attachmentFileUpload: "attachmentFileUpload",
    // monthStartingDay: "monthStartingDay",
    // startMonth: "startMonth",
    // startMonthSemiAnnually: "startMonthSemiAnnually",
    // startMonthAnnually: "startMonthAnnually",
    time: "time",
    communicationTemplateHTML: "communicationTemplateHTML",
  },
  [manageCommunicationFormNames.EMAIL_LAYOUT_INFO]: {
    layoutDescription: "layoutDescription",
    layoutName: "layoutName",
    layoutHTML: "layoutHTML",
  },
};

// export const channelForCommunication = [
//   {
//     label: "Email",
//     value: 1,
//   },
//   {
//     label: "SMS",
//     value: 2,
//   },
//   {
//     label: "Email & SMS",
//     value: 3,
//   },
//   {
//     label: "SMS & Email",
//     value: 3,
//   },
// ]

export const CategoryOptions = [
  // {
  //   label: "Plan",
  //   value: 1,
  // },
  // {
  //   label: "Employee",
  //   value: 2,
  // },
  {
    label: "Payroll and Funding",
    value: 3,
  },
  {
    label: "Miscellaneous",
    value: 4,
  },
  // {
  //   label: "Rollover In",
  //   value: 5,
  // },
  // {
  //   label: "Enrollment",
  //   value: 6,
  // },
  // {
  //   label: "Loans and Distributions",
  //   value: 7,
  // },
];

export const CategoryEnumOptions = [
  // {
  //   label: "Plan",
  //   value: "plan",
  // },
  // {
  //   label: "Employee",
  //   value: "Employee",
  // },
  {
    label: "Payroll and Funding",
    value: "Payroll",
  },
  {
    label: "Miscellaneous",
    value: "Miscellaneous",
  },
  // {
  //   label: "Rollover In",
  //   value: "RollOverIn",
  // },
  // {
  //   label: "Enrollment",
  //   value: "Enrollment",
  // },
  // {
  //   label: "Loans and Distributions",
  //   value: "LoansAndDistribution",
  // },
];

export const channelForCommunication = {
  Email: 1,
  // SMS: 2,
  // "Email&SMS": 3,
  // "SMS&Email": 4,
};

// export const ALL_MANAGE_COMMUNICATION_ROUTES = [
//   ...MANAGE_COMMUNICATION_MENU,
//   {
//     id: "holidayCalendar",
//     contentHeader: "Maintenance",
//     path: MANAGE_MAINTENANCE_ROUTES.HOLIDAY_CALENDAR,
//     breadCrumbs: [
//       {
//         label: "Manage Maintenance",
//         link: MANAGE_MAINTENANCE_ROUTES.HOLIDAY_CALENDAR,
//       },
//     ],
//   },
//   {
//     id: "holidayCalendar",
//     contentHeader: "Holiday",
//     path: MANAGE_MAINTENANCE_ROUTES.ADD_HOLIDAY,
//     breadCrumbs: [
//       {
//         label: "Home",
//         link: ROUTES.HOME,
//       },
//       {
//         label: "Manage Holiday Calendar",
//         link: MANAGE_MAINTENANCE_ROUTES.HOLIDAY_CALENDAR,
//       },
//     ],
//   },
//   {
//     id: "managePlanGroup",
//     contentHeader: "Maintenance",
//     path: MANAGE_MAINTENANCE_ROUTES.MANAGE_PLAN_GROUP,
//     breadCrumbs: [
//       {
//         label: "Manage Maintenance",
//         link: MANAGE_MAINTENANCE_ROUTES.MANAGE_PLAN_GROUP,
//       },
//     ],
//   },
//   {
//     id: "managePlanGroup",
//     contentHeader: "Plan Group",
//     path: MANAGE_MAINTENANCE_ROUTES.ADD_PLAN_GROUP,
//     breadCrumbs: [
//       {
//         label: "Home",
//         link: ROUTES.HOME,
//       },
//       {
//         label: "Maintenance",
//         link: MANAGE_MAINTENANCE_ROUTES.MANAGE_PLAN_GROUP,
//       },
//     ],
//   },
// ];
